import { __awaiter, __generator } from "tslib";
import { fetchSingleSubEntity } from './http/fetch-single-sub-entity';
import { SubEntityType } from './models/sub-entity-type';
export var fetchFrequentlyAskedQuestion = function (groupId, faqCode) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchSingleSubEntity(groupId, SubEntityType.FrequentlyAskedQuestions, faqCode)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
